(() => {
class $d2ef8d3490be9980$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".gallery-element"
        ];
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        new LuminousGallery(holderElement.querySelectorAll("a"));
    }
}


class $38c9b58d377956eb$export$2e2bcd8739ae039 {
    /**
	 *
	 * @param {HTMLElement} sliderElement
	 * @param {HTMLElement} controlsElement
	 */ static sliderControls(sliderElement, controlsElement) {
        const slider = new Splide(sliderElement, {
            arrows: false,
            type: "loop",
            pagination: false
        });
        slider.mount();
        const pagination = [];
        const arrows = [];
        controlsElement.querySelectorAll("[data-slider-control]").forEach((c)=>{
            (isNaN(parseInt(c.dataset.sliderControl)) ? arrows : pagination).push(c);
        });
        pagination.forEach((c)=>c.addEventListener("click", ()=>slider.go(parseInt(c.dataset.sliderControl))));
        arrows.forEach((c)=>c.addEventListener("click", ()=>slider.go(c.dataset.sliderControl)));
        slider.on("move", (index)=>{
            pagination.forEach((c)=>{
                c.classList.toggle("selected", c.dataset.sliderControl === index.toString());
            });
        });
    }
}


class $dc7e05a21f885212$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".offers-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const controlsElement = this.#holderElement.querySelector(".card-slider-controls");
        this.#holderElement.querySelectorAll(".splide").forEach((s)=>{
            (0, $38c9b58d377956eb$export$2e2bcd8739ae039).sliderControls(s, controlsElement);
        });
    }
}


/**
 * A light weight alternative to using moment.js
 *
 * No Dependencies
 */ const $e93a6c92886be7a5$var$DateFormat = {
    daysOfWeek: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    format: function(date, format) {
        switch(format){
            case "dd-mm-yyyy":
                return [
                    this.getDate(date, "dd"),
                    this.getMonth(date, "mm"),
                    this.getYear(date, "yyyy")
                ].join("-");
            case "yyyy-mm-dd":
                return [
                    this.getYear(date, "yyyy"),
                    this.getMonth(date, "mm"),
                    this.getDate(date, "dd")
                ].join("-");
            case "d mmm yyyy":
                return [
                    this.getDate(date, "d"),
                    this.getMonth(date, "mmm"),
                    this.getYear(date, "yyyy")
                ].join(" ");
        }
    },
    getYear: function(date, format) {
        if (format === "yy") return (date.getFullYear() + "").slice(2);
        else return date.getFullYear() + "";
    },
    getMonth: function(date, format) {
        switch(format){
            case "m":
                return date.getMonth() + 1 + "";
            case "mm":
                return date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1 + "";
            case "mmm":
                return this.months[date.getMonth()].slice(0, 3);
            case "mmmm":
                return this.months[date.getMonth()];
            default:
                return this.months[date.getMonth()];
        }
    },
    getDate: function(date, format) {
        switch(format){
            case "d":
                return date.getDate() + "";
            case "dd":
                return date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + "";
            case "ddd":
                return this.daysOfWeek[date.getDay()].slice(0, 3);
            case "dddd":
                return this.daysOfWeek[date.getDay()];
            default:
                return this.daysOfWeek[date.getDay()];
        }
    },
    nights: function(date1, date2) {
        const oneDay = 86400000;
        return Math.floor((date1 - date2) / oneDay);
    },
    /**
	 *
	 * @param {Date} date
	 * @param {int} amount
	 * @param {string} unit
	 * @returns {Date}
	 */ add: (date, amount, unit)=>{
        const newDate = new Date(+date);
        switch(unit){
            case "month":
            case "months":
                newDate.setMonth(newDate.getMonth() + amount);
                return newDate;
            case "day":
            case "days":
                newDate.setDate(newDate.getDate() + amount);
                return newDate;
            default:
                throw new Error(`Invalid unit: ${unit}`);
        }
    }
};
var $e93a6c92886be7a5$export$2e2bcd8739ae039 = $e93a6c92886be7a5$var$DateFormat;


class $b89db87ccaf9b090$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".main-header"
        ];
    /** @type {HTMLElement} */ #holderElement;
    #checkInPicker = null;
    #checkOutPicker = null;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        this.#headerScroll();
        this.#bookingOverlay(document.querySelector(".booking-overlay"));
        const navOverlay = document.querySelector(".navigation-overlay");
        document.querySelectorAll(".navigation-overlay-toggle").forEach((btn)=>btn.addEventListener("click", ()=>navOverlay.classList.toggle("open", !navOverlay.classList.contains("open"))));
    }
    #headerScroll() {
        const heroExists = !!document.querySelector(".hero-element");
        if (!heroExists) {
            this.#holderElement.classList.add("scrolled");
            return;
        }
        const SCROLL_BREAKPOINT = 300;
        let scrolled = window.scrollY > SCROLL_BREAKPOINT;
        this.#holderElement.classList.toggle("scrolled", scrolled);
        window.addEventListener("scroll", ()=>{
            if (scrolled !== window.scrollY > SCROLL_BREAKPOINT) {
                scrolled = !scrolled;
                this.#holderElement.classList.toggle("scrolled", scrolled);
            }
        });
    }
    /**
	 * @param {HTMLElement} element
	 */ #bookingOverlay(element) {
        if (!element) return;
        const radioInputs = Array.from(element.querySelectorAll('input[type="radio"]'));
        const radioLabels = radioInputs.map((i)=>i.closest("label")).filter((l)=>l);
        radioInputs.forEach((i)=>{
            i.addEventListener("change", (event)=>{
                radioLabels.forEach((l)=>l.classList.remove("selected"));
                i.closest("label")?.classList.add("selected");
                let checkIn = 0;
                let checkOut = 1;
                if (event.currentTarget.value === "tomorrow") {
                    checkIn = 1;
                    checkOut = 2;
                } else if (event.currentTarget.value === "weekend") {
                    checkIn = 6 - new Date().getDay();
                    checkOut = 7 - new Date().getDay();
                }
                this.#checkOutPicker.setDate((0, $e93a6c92886be7a5$export$2e2bcd8739ae039).add(new Date(), checkOut, "days"));
                this.#checkInPicker.setDate((0, $e93a6c92886be7a5$export$2e2bcd8739ae039).add(new Date(), checkIn, "days"));
            });
        });
        let hasOpenedBookingOverlay = false;
        document.querySelectorAll(".booking-overlay-toggle").forEach((btn)=>{
            btn.addEventListener("click", ()=>{
                const openState = element.getAttribute("data-open-state");
                if ([
                    "opening",
                    "closing"
                ].includes(openState)) return;
                const isOpen = openState === "opened";
                element.setAttribute("data-open-state", isOpen ? "closing" : "opening");
                window.setTimeout(()=>{
                    element.setAttribute("data-open-state", isOpen ? "closed" : "opened");
                }, 1000);
                // element.classList.toggle('open', !isOpen);
                if (!hasOpenedBookingOverlay) {
                    window.loadScript("pikaday").then(()=>this.#initDatepicker(element));
                    hasOpenedBookingOverlay = true;
                }
            });
        });
    }
    /**
	 * @param {HTMLElement} bookingOverlay
	 */ #initDatepicker(bookingOverlay) {
        const checkInInput = bookingOverlay.querySelector("#bo--check-in-input");
        const checkOutInput = bookingOverlay.querySelector("#bo--check-out-input");
        const defaultCheckout = (0, $e93a6c92886be7a5$export$2e2bcd8739ae039).add(new Date(), 2, "days");
        this.#checkInPicker = new Pikaday({
            field: document.getElementById("bo--check-in"),
            toString: (date)=>(0, $e93a6c92886be7a5$export$2e2bcd8739ae039).format(date, "d mmm yyyy"),
            defaultDate: new Date(),
            setDefaultDate: true,
            minDate: new Date(),
            onSelect: (date)=>{
                checkInInput.value = (0, $e93a6c92886be7a5$export$2e2bcd8739ae039).format(date, "yyyy-mm-dd");
                if (!checkOutInput.value || new Date(checkOutInput.value).valueOf() < date.valueOf()) {
                    this.#checkOutPicker.show();
                    this.#checkOutPicker.clear();
                }
                this.#checkOutPicker.setMinDate((0, $e93a6c92886be7a5$export$2e2bcd8739ae039).add(date, 1, "day"));
            }
        });
        this.#checkOutPicker = new Pikaday({
            field: document.getElementById("bo--check-out"),
            minDate: new Date(),
            defaultDate: defaultCheckout,
            setDefaultDate: true,
            toString: (date)=>(0, $e93a6c92886be7a5$export$2e2bcd8739ae039).format(date, "d mmm yyyy"),
            onSelect: (date)=>{
                checkOutInput.value = (0, $e93a6c92886be7a5$export$2e2bcd8739ae039).format(date, "yyyy-mm-dd");
            }
        });
        checkInInput.value = (0, $e93a6c92886be7a5$export$2e2bcd8739ae039).format(new Date(), "yyyy-mm-dd");
        checkOutInput.value = (0, $e93a6c92886be7a5$export$2e2bcd8739ae039).format(defaultCheckout, "yyyy-mm-dd");
    }
}


class $8fa2eb92bcb246bc$export$2e2bcd8739ae039 {
    /**
	 *
	 * @type {Array<{element: HTMLElement, module: Object}>}
	 */ #holders = [];
    /**
	 *
	 * @param {Array<Object>} modules
	 */ constructor(modules){
        for (const module of modules)this.#holders = this.#holders.concat(module.getHolderSelectors().flatMap((selector)=>[
                ...document.querySelectorAll(selector)
            ]).map((holder)=>Object.create({
                element: holder,
                module: module
            })));
        document.addEventListener("dependency-chain:loaded", this.#createReadyModules.bind(this));
        this.#createReadyModules();
    }
    #createReadyModules() {
        for (const holder of this.#holders)if (holder.element.dataset.module === "ready") {
            new holder.module(holder.element);
            holder.element.dataset.module = "created";
        }
    }
}



class $f9f01845c0e43ef5$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".rooms-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const controlsElement = this.#holderElement.querySelector(".card-slider-controls");
        this.#holderElement.querySelectorAll(".splide").forEach((s)=>{
            (0, $38c9b58d377956eb$export$2e2bcd8739ae039).sliderControls(s, controlsElement);
        });
    }
}



class $bc1381ae91d37181$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".cards-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const controlsElement = this.#holderElement.querySelector(".card-slider-controls");
        this.#holderElement.querySelectorAll(".splide").forEach((s)=>{
            (0, $38c9b58d377956eb$export$2e2bcd8739ae039).sliderControls(s, controlsElement);
        });
    }
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $975251fe1bb40e94$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
// do not edit .js files directly - edit src/index.jst
var $975251fe1bb40e94$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $975251fe1bb40e94$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $975251fe1bb40e94$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($975251fe1bb40e94$export$406cfe323c8bb8e4 || ($975251fe1bb40e94$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $975251fe1bb40e94$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $975251fe1bb40e94$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $975251fe1bb40e94$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($975251fe1bb40e94$export$3b0d6d7590275603.instance) {
            if (!$975251fe1bb40e94$var$fastDeepEqual(this.options, $975251fe1bb40e94$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($975251fe1bb40e94$export$3b0d6d7590275603.instance.options)}`);
            return $975251fe1bb40e94$export$3b0d6d7590275603.instance;
        }
        $975251fe1bb40e94$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $975251fe1bb40e94$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $975251fe1bb40e94$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $975251fe1bb40e94$export$406cfe323c8bb8e4.LOADING;
        return $975251fe1bb40e94$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$975251fe1bb40e94$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}


class $0c542726c94bf917$export$2e2bcd8739ae039 {
    /**
	 * @param {string} propertySlug
	 * @return {Promise<any>}
	 */ static fetchProperty(propertySlug) {
        return fetch(`/api/properties/${propertySlug}/`).then((rs)=>rs.json());
    }
    /**
	 * @param {string} propertySlug
	 * @return {Promise<any>}
	 */ static fetchPropertyPlaces(propertySlug) {
        return fetch(`/api/properties/${propertySlug}/places/`).then((rs)=>rs.json());
    }
}


class $3e20a1d85f662af7$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".things-to-do-element"
        ];
    static ALL_CATEGORIES = 0;
    /** @type {HTMLElement} */ #holderElement;
    /** @type {object} */ #property;
    /** @type {object[]} */ #places;
    /** @type {google.maps.Map} */ #map;
    /** @type {Loader} */ #loader;
    /** @type {google.maps.MapsLibrary} */ #mapsLibrary;
    /** @type {google.maps.CoreLibrary} */ #coreLibrary;
    /** @type {google.maps.MarkerLibrary} */ #markerLibrary;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        this.#loader = new (0, $975251fe1bb40e94$export$3b0d6d7590275603)({
            apiKey: window.config.googleMapsApiKey,
            version: "weekly"
        });
        this.#initMap();
    }
    async #initMap() {
        this.#mapsLibrary = await this.#loader.importLibrary("maps");
        this.#coreLibrary = await this.#loader.importLibrary("core");
        this.#markerLibrary = await this.#loader.importLibrary("marker");
        this.#map = new this.#mapsLibrary.Map(this.#holderElement.querySelector(".map"), {
            zoom: 8,
            center: {
                lat: -34.397,
                lng: 150.644
            },
            disableDefaultUI: true,
            maxZoom: 15,
            zoomControl: true,
            mapTypeId: "terrain"
        });
        await Promise.all([
            (0, $0c542726c94bf917$export$2e2bcd8739ae039).fetchProperty(this.#holderElement.dataset.propertySlug),
            (0, $0c542726c94bf917$export$2e2bcd8739ae039).fetchPropertyPlaces(this.#holderElement.dataset.propertySlug),
            await window.loadScript("snazzyInfoWindow")
        ]).then((values)=>{
            this.#property = values[0];
            this.#places = values[1];
        });
        this.#property.marker = new this.#markerLibrary.Marker({
            position: {
                lat: this.#property.address.latitude,
                lng: this.#property.address.longitude
            },
            map: this.#map,
            title: this.#property.name,
            icon: {
                url: window.config.themeDirectory + "/img/logo-map-pin.png",
                scaledSize: {
                    width: 50,
                    height: 50,
                    widthUnit: "px",
                    heightUnit: "px"
                }
            },
            zIndex: this.#markerLibrary.Marker.MAX_ZINDEX
        });
        this.#property.infoWindow = new SnazzyInfoWindow({
            marker: this.#property.marker,
            content: `<h4>${this.#property.name}</h4><p>${this.#property.address.address}</p>`,
            closeWhenOthersOpen: true,
            showCloseButton: false
        });
        this.#places.forEach((p)=>{
            const location = {
                lat: p.latitude,
                lng: p.longitude
            };
            p.marker = new this.#markerLibrary.Marker({
                position: location,
                map: this.#map,
                title: p.name,
                icon: window.config.themeDirectory + "/img/map-pin.svg"
            });
            p.infoWindow = new SnazzyInfoWindow({
                marker: p.marker,
                content: [
                    `<h4>${p.name}</h4><p>${p.address}</p>`,
                    p.website ? `<a href="${p.website}" target="_blank">website</a>` : ""
                ].join(""),
                closeWhenOthersOpen: true,
                showCloseButton: false
            });
        });
        this.#filterCategories($3e20a1d85f662af7$export$2e2bcd8739ae039.ALL_CATEGORIES);
        const controlsElement = this.#holderElement.querySelector(".category-controls");
        const all = '<button type="button" class="btn selected" data-category-id="0">All</button>';
        const added = [];
        controlsElement.innerHTML = all + this.#places.flatMap((p)=>p.categories).filter((p)=>{
            if (added.includes(p.id)) return false;
            return added.push(p.id);
        }).map((p)=>`<button type="button" class="btn" data-category-id="${p.id}">${p.name}</button>`).join("");
        const buttons = controlsElement.querySelectorAll("button");
        buttons.forEach((btn)=>btn.addEventListener("click", (e)=>{
                this.#filterCategories(parseInt(e.currentTarget.dataset.categoryId));
                buttons.forEach((b)=>b.classList.remove("selected"));
                btn.classList.add("selected");
            }));
        this.#holderElement.querySelectorAll(".controls ul button").forEach((button)=>{
            button.addEventListener("click", ()=>{
                const id = parseInt(button.value);
                for (const place of this.#places)if (id === place.id) place.infoWindow.open();
            });
        });
    }
    #filterCategories = (id)=>{
        const bounds = new this.#coreLibrary.LatLngBounds();
        this.#places.forEach((p)=>{
            const show = id === $3e20a1d85f662af7$export$2e2bcd8739ae039.ALL_CATEGORIES || !!p.categories.find((c)=>c.id === id);
            p.marker.setMap(show ? this.#map : null);
            p.infoWindow.close();
            show && bounds.extend(p.marker.position);
        });
        this.#map.fitBounds(bounds);
        const placeLis = this.#holderElement.querySelectorAll("ul li");
        placeLis.forEach((li)=>{
            const button = li.querySelector("button");
            const categoryIds = button.dataset.categories.split(",").map(Number);
            if (id === $3e20a1d85f662af7$export$2e2bcd8739ae039.ALL_CATEGORIES) li.classList.remove("d-none");
            else li.classList.toggle("d-none", !categoryIds.includes(id));
        });
    };
}



class $51f51b1efc1e19bf$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".section-reviews"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const controlsElement = this.#holderElement.querySelector(".card-slider-controls");
        this.#holderElement.querySelectorAll(".splide").forEach((s)=>{
            (0, $38c9b58d377956eb$export$2e2bcd8739ae039).sliderControls(s, controlsElement);
        });
    }
}


class $b20b130bf22a1ff2$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".form-element__form"
        ];
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        holderElement.querySelectorAll(".field input").forEach((i)=>{
            const label = holderElement.querySelector(`[for="${i.id}"]`);
            if (i.type === "date") label.classList.add("active");
            else {
                i.addEventListener("focus", ()=>label.classList.add("active"));
                i.addEventListener("blur", ()=>{
                    !i.value && label.classList.remove("active");
                });
            }
        });
    }
}


class $f4869d69bec76ef4$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".blog"
        ];
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        const filters = holderElement.querySelectorAll(".filters form");
        const path = window.location.pathname.replace(/\/+$/, "");
        for (const filter of filters){
            const select = filter.querySelector("select");
            for (const option of select.options)if (path === option.value.replace(/\/+$/, "")) select.value = option.value;
            select.addEventListener("change", ()=>{
                window.location = select.value;
            });
        }
    }
}


class $2f22e38cecd73b39$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            'a[href^="tel:"]'
        ];
    /**
	 *
	 * @param {HTMLAnchorElement} holderElement
	 */ constructor(holderElement){
        holderElement.href = holderElement.href.replaceAll(/[\s()]/g, "");
    }
}


class $653b840774654f65$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".subscribe-form-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        holderElement.querySelectorAll(".mc-field-group input").forEach((i)=>{
            const label = holderElement.querySelector(`[for="${i.id}"]`);
            i.addEventListener("focus", ()=>label.classList.add("active"));
            i.addEventListener("blur", ()=>{
                !i.value && label.classList.remove("active");
            });
        });
        const submit = holderElement.querySelector('#mc_embed_signup input[type="submit"]');
        if (submit) {
            submit.classList.add("btn", "btn-outline-secondary");
            submit.classList.remove("button");
        }
    }
}


class $55c3faaaec82f620$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".faq-element"
        ];
    /**
	 * @param {HTMLElement} holderElement
	 */ constructor(holderElement){
        const questions = Array.from(holderElement.querySelectorAll("[aria-controls]"));
        const answers = Array.from(holderElement.querySelectorAll(".answer"));
        /**
		 * @param {Event} event
		 */ const toggle = (event)=>{
            const current = event.currentTarget;
            const answer = document.getElementById(current.getAttribute("aria-controls"));
            if (!answer) return;
            const openAnswers = answers.filter((a)=>!a.hasAttribute("hidden"));
            window.requestAnimationFrame(()=>{
                if (answer.hasAttribute("hidden")) {
                    answer.removeAttribute("hidden");
                    current.setAttribute("aria-expanded", "true");
                    const height = answer.scrollHeight;
                    answer.style.maxHeight = "0px";
                    answer.getBoundingClientRect(); // force reflow
                    answer.style.maxHeight = `${height}px`;
                    answer.addEventListener("transitionend", function openTransition(event) {
                        if (event.propertyName !== "max-height") return;
                        answer.style.maxHeight = "";
                        answer.removeEventListener("transitionend", openTransition);
                    });
                }
                for (const openAnswer of openAnswers){
                    openAnswer.style.maxHeight = `${openAnswer.scrollHeight}px`;
                    openAnswer.getBoundingClientRect(); // force reflow
                    openAnswer.style.maxHeight = "0px";
                    document.getElementById(openAnswer.getAttribute("aria-labelledby")).querySelector("button").setAttribute("aria-expanded", "false");
                    openAnswer.addEventListener("transitionend", function closeTransition(event) {
                        if (event.propertyName !== "max-height") return;
                        openAnswer.style.maxHeight = "";
                        openAnswer.setAttribute("hidden", "");
                        openAnswer.removeEventListener("transitionend", closeTransition);
                    });
                }
            });
        };
        for (const question of questions)question.addEventListener("click", toggle);
    }
}


const $f588187e97d40c34$var$modules = [
    (0, $bc1381ae91d37181$export$2e2bcd8739ae039),
    (0, $b89db87ccaf9b090$export$2e2bcd8739ae039),
    (0, $3e20a1d85f662af7$export$2e2bcd8739ae039),
    (0, $51f51b1efc1e19bf$export$2e2bcd8739ae039),
    (0, $f9f01845c0e43ef5$export$2e2bcd8739ae039),
    (0, $d2ef8d3490be9980$export$2e2bcd8739ae039),
    (0, $dc7e05a21f885212$export$2e2bcd8739ae039),
    (0, $b20b130bf22a1ff2$export$2e2bcd8739ae039),
    (0, $f4869d69bec76ef4$export$2e2bcd8739ae039),
    (0, $2f22e38cecd73b39$export$2e2bcd8739ae039),
    (0, $653b840774654f65$export$2e2bcd8739ae039),
    (0, $55c3faaaec82f620$export$2e2bcd8739ae039)
];
new (0, $8fa2eb92bcb246bc$export$2e2bcd8739ae039)($f588187e97d40c34$var$modules);

})();
//# sourceMappingURL=main.js.map
